import { useRef } from 'react';

export const useMemoizeArgs = <T>(args: Array<T>): number => {
	const ref = useRef<{ argsString: string; flag: number }>({ argsString: '', flag: 0 });
  
	const argsString = JSON.stringify(args);
	if (ref.current.argsString !== argsString) {
		ref.current = { argsString, flag: ref.current.flag + 1 };
	}
  
	return ref.current.flag;
};